import { Navigate } from 'react-router-dom'
import { useAdminAuth } from '../context/AdminAuthContext'
import { Spinner } from '../components/ui'

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAdminAuth()

  if (loading) {
    return (
      <div className="min-h-screen bg-surface-dark flex items-center justify-center">
        <div className="text-center space-y-3">
          <Spinner size={32} />
          <p className="text-gray-500 text-sm font-display">Loading admin panel...</p>
        </div>
      </div>
    )
  }

  // For demo tokens
  const demoToken = localStorage.getItem('tonys-admin-token') === 'demo-token'
  if (!isAuthenticated && !demoToken) {
    return <Navigate to="/login" replace />
  }

  return children
}
